<template>
  <div class="ma-6">
    <div class="maxh-4">
      <EditVariableDialog ref="dialog" />

      <v-simple-table dense>
        <template v-slot:default>
          <colgroup>
            <col width="120" />
            <col width="60" />
            <col width="60" />
            <col width="60" />
            <col width="60" />
            <col width="60" />
            <col width="60" />
          </colgroup>
          <thead>
            <tr>
              <th>Variável</th>
              <th class="text-right" v-for="p in props" :key="p">{{ p }}</th>
              <th>Comentários</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(variable, idx) in activeVariables"
              :key="idx"
              class="clickable"
              @click="edit(variable)"
            >
              <td>{{ variable.code }}</td>
              <td class="mono text-right" v-for="p in props" :key="p">
                {{ variable[p] }}
              </td>
              <td>{{ variable.comments || '─' }}</td>
            </tr>
          </tbody>
          <tbody v-if="includeInactive">
            <tr
              v-for="(variable, idx) in inactiveVariables"
              :key="idx"
              @click="edit(variable)"
            >
              <td class="strike-through grey--text">{{ variable.code }}</td>
              <td class="strike-through grey--text mono text-right" v-for="p in props" :key="p">
                {{ variable[p] }}
              </td>
              <td class="grey--text">{{ variable.comments || '─' }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-btn small class="my-4" @click="addVariable">Nova Variável...</v-btn>
    </div>
    <ORow fill-x right class="mt-12">
      <v-switch v-model="includeInactive" label="Mostrar ocultas" />
    </ORow>
  </div>
</template>

<script>
import EditStore from './EditStore'
import EditVariableDialog from './EditVariableDialog.vue'

export default {
  components: { EditVariableDialog },
  tabTitle: 'Variáveis',
  data() {
    return {
      includeInactive: false,
      props: ['pgn', 'spnStart', 'spnLen', 'multiplier', 'divisor', 'opts']
    }
  },
  computed: {
    value() {
      return EditStore.row
    },
    activeVariables() {
      return this.value.variables.filter((x) => !x.isInactive)
    },
    inactiveVariables() {
      return this.value.variables.filter((x) => x.isInactive)
    }
  },
  methods: {
    async edit(variable) {
      const res = await this.$refs.dialog.open(variable.id)
      if (res === 'RELOAD') {
        this.$emit('reload')
      }
    },

    async addVariable() {
      const res = await this.$refs.dialog.open(null)
      if (res === 'RELOAD') {
        this.$emit('reload')
      }
    }
  }
}
</script>

<style></style>
